// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","Photos__row":"tc_a bhs_a bhs_r bhs_j","Photos__img":"tc_b bhs_b"};